import { GarageListItemPremiumServices } from "@App/Components/GarageListItem/GarageListItemPremiumServices";
import { GaragePropertiesList } from "@App/Components/GarageListItem/GaragePropertiesList";
import { useGaragePropertyContext } from "@App/hooks/contexts/useGaragePropertyContext";
import type { Garage, Organization, Service } from "@App/types";
import { getConfig } from "@App/utils/getConfig";
import type React from "react";
import type { TFunction } from "react-i18next";
import { GarageCTAButton } from "./GarageCTAButton";

type Props = {
  garage: Garage;
  showAsNonBookable: boolean;
  bookable: boolean;
  service?: Service;
  organization: Organization;
  displayPremiumServices: boolean;
  showPhoneNumber: boolean;
  handleTogglePhone: () => void;
  handleClick: () => void;
  t: TFunction;
};

export const GaragePricingAndProperties: React.FC<Props> = ({
  garage,
  bookable,
  service,
  organization,
  showAsNonBookable,
  displayPremiumServices,
  showPhoneNumber,
  handleTogglePhone,
  handleClick,
  t,
}) => {
  const { availableGarageProperties } = useGaragePropertyContext();

  const { garageListItem } = getConfig(organization);

  if (!bookable) return;

  return (
    <div className="px-5 third lg:border-r-[0.5px] lg:border-neutral-100 lg:pr-8">
      <div className="lg:flex lg:flex-col lg:justify-between lg:h-full">
        {garageListItem?.benefitBadge?.component}

        <GaragePropertiesList
          garageProperties={garage.garageProperties}
          availableGarageProperties={availableGarageProperties}
        />

        {displayPremiumServices && (
          <GarageListItemPremiumServices
            garage={garage}
            service={service}
            organization={organization}
            bookable={bookable}
          />
        )}

        {bookable && !showAsNonBookable && (
          <GarageCTAButton
            label={t("garageList.gotoAppointmentselect")}
            onClick={handleClick}
            className="hidden lg:block"
          />
        )}

        {showAsNonBookable && garage.phone && !showPhoneNumber && (
          <GarageCTAButton
            label={t("garageList.showPhoneNumber")}
            onClick={handleTogglePhone}
            className="hidden lg:block"
          />
        )}

        {showAsNonBookable && showPhoneNumber && (
          <GarageCTAButton
            label={garage.phone}
            href={`tel:${garage.phone}`}
            className="font-serif font-bold text-center hidden lg:block"
          />
        )}
      </div>
    </div>
  );
};
